import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const SubscriberAttributesHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);

  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }
  return (
    <Modal
      title="Subscriber Attributes"
      onClose={doClose}
      content={() => (
        <>
          <p>RADIUS and REST subscribers.</p>
          <ul>
            <li>
              <b>IP-ADDRESS</b>: Subscriber IP address.
            </li>
            <li>
              <b>SUBSCRIBER-ID</b>: Subscriber ID.
            </li>
            <li>
              <b>RATE-POLICY</b>: Subscriber policy.
            </li>
            <li>
              <b>ASSIGNED-BY</b>: Where the assignment of the subscriber to the
              policy comes from. It can come from the REST API (rest), from
              RADIUS (radius), from a billing system integration (billing) or
              from the configuration rules (rules).
            </li>
            <li>
              <b>BILLING BLOCK</b>: Whether the subscriber is blocked due to the
              Billing system reporting that the subscriber is not paying
            </li>
            <li>
              <b>QUOTAS</b>: Whether the time or volume quotas are enabled, and
              if enabled, it informs when the quotas are blocking the
              subscriber. If quotas are enabled, you can click on this field and
              get more details or manage the quotas.
            </li>
            <li>
              <b>SUBSCRIBER-GROUPS</b>: This field says if this subscriber is
              part of any subscriber groups. If it is, you can click on this
              field and see all the subscriber groups it belongs to.
            </li>
            <li>
              <b>UPDATED</b>: Last update date.
            </li>
            <li>
              <b>ACTIVE</b>: Whether the subscriber is active or not.
            </li>
            <li>
              <b>ACTIONS</b>: Allowed operations on this subscriber (e.g.
              delete).
            </li>
          </ul>
          <p>Chart selectors:</p>
          <ul>
            <li>
              <i className="material-icons valign-icon">format_line_spacing</i>{" "}
              Selects the number of subscribers shown in the table.
            </li>
            <li>
              <i className="material-icons valign-icon">folder_open</i> Selects
              the subscribers with the specified policy.
            </li>
            <li>
              <i className="material-icons valign-icon">group</i> Selects the
              subscribers matching the specified address or group.
            </li>
            <li>
              <i className="material-icons valign-icon">settings</i> Selects the
              subscribers matching the specified data sourceqli
            </li>
          </ul>
          <p>Click on the corresponding IP address to show subscriber data.</p>{" "}
        </>
      )}
    />
  );
};
export default SubscriberAttributesHelpModal;
